<app-accordion
  [showArrow]="
    taxesByType?.totalTaxes?.amount !== 0 &&
    taxesByType?.totalAmount?.amount !== 0 &&
    !!taxesByType?.taxes &&
    taxesByType?.passengerCount > 1
  "
>
  <div class="is-size-6 weight-medium has-text-grey" title>
    <span *ngIf="type !== 'fares'">
      {{ 'shared.' + taxesByType?.passengerType | translate }}
      x {{ taxesByType?.passengerCount }}
    </span>
    <span *ngIf="type === 'fares'">
      {{ !!taxesByType?.detail && taxesByType?.detail }}
    </span>
  </div>
  <div class="column is-size-6 weight-medium has-text-grey" price>
    <!-- if Taxes -->
    <span class="is-pulled-right" *ngIf="type === 'taxes'">
      {{
        !!taxesByType?.totalTaxesPerPassenger?.currency
          ? (taxesByType?.totalTaxesPerPassenger?.amount
            | currency : taxesByType?.totalTaxesPerPassenger?.currency : 'symbol' : '1.2-2' : 'en-US')
          : (taxesByType?.totalTaxesPerPassenger?.amount | number : '1.2-2' : 'en-US')
      }}</span
    >
    <!--if net (Faresummary) -->
    <span class="is-pulled-right" *ngIf="type === 'fares'">
      {{
        !!taxesByType?.baseAmount?.currency
          ? (taxesByType?.baseAmount?.amount | currency : taxesByType?.baseAmount?.currency : 'symbol' : '1.2-2' : 'en-US')
          : (taxesByType?.baseAmount?.amount | number : '1.2-2' : 'en-US')
      }}</span
    >
    <!-- if Penalties -->
    <span class="is-pulled-right" *ngIf="type === 'penalties'">
      {{
        !!taxesByType?.amount?.currency
          ? (taxesByType?.amount?.amount | currency : taxesByType?.amount?.currency : 'symbol' : '1.2-2' : 'en-US')
          : (taxesByType?.amount?.amount | number : '1.2-2' : 'en-US')
      }}</span
    >

    <!-- if fixed charges -->
    <span class="is-pulled-right" *ngIf="type === 'charges'">
      {{
        !!taxesByType?.fixedCharge?.currency
          ? (taxesByType?.amount | currency : taxesByType?.fixedCharge?.currency : 'symbol' : '1.2-2' : 'en-US')
          : (taxesByType?.amount | number : '1.2-2' : 'en-US')
      }}</span
    >
  </div>

  <div content>
    <div class="column is-offset-1 has-text-grey">
      <div *ngFor="let taxe of taxesByType?.taxes" class="columns mb-1pt">
        <div class="column is-2 p-1">
          <span class="is-size-6">
            {{ taxe?.code }}
          </span>
        </div>
        <div class="column is-8 p-1">
          <span class="is-size-6">
            {{ taxe?.amount?.amount | currency : taxe?.amount?.currency : 'symbol' : '1.2-2' : 'en-US' }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-accordion>
